<template>
    <li class="treeNodeLi">
        <div class="treeNodeShow">
            <span v-if="isFolder" class="icon" @click="toggle">
                <span v-show="!open" style="font-weight:200"><el-icon><arrow-right /></el-icon></span>
                <span v-show="open" style="font-weight:200"><el-icon><arrow-down /></el-icon></span>
            </span>
            <span v-else class="icon">
                <el-icon>-</el-icon>
            </span>
            <span @click="selectTreeNode">
                <input v-if="showCheckBox" :type="inputType" :checked="checked"> 
                <span class="departName-span">{{ node.Name }}</span>
            </span>
        </div>
        <transition name="el-zoom-in-top">
            <ul class="treeNodeUl" v-show="open">
                <treeNode v-for="(node, index) in node.Children"
                    :key="node.Id"
                    :node="node"
                    :treeStore="treeStore">
                </treeNode>
            </ul>
        </transition>
    </li>
</template>

<style>
    .treeNodeShow{
        margin-bottom: 10px;
        font-size:16px;
        cursor:pointer
    }
    .treeNodeShow .icon{
        width:20px;
    }
    .treeNodeUl{
        padding-left:20px;
        list-style: none;
    }
</style>

<script>
    import { ArrowRightBold,ArrowDownBold,Minus } from "@element-plus/icons-vue";

    export default{
        name:"treeNode",
        components:{
            'arrow-right':ArrowRightBold,
            'arrow-down':ArrowDownBold,
            'minus':Minus
        },
        props:{
            node:Object,
            treeStore:{
                type:[Array,Number]
            },
        },
        inject:[
            'singleSelect',
            'showCheckBox',
            'selectNode',
            'removeNode'
        ],
        data:function(){
            return{
                open:false
            }  
        },
        computed:{
            isFolder:function(){
                return this.node.hasOwnProperty("Children") && this.node.Children.length > 0; 
            },
            checked:function(){
                if(this.singleSelect){
                    return this.treeStore == this.node.Id;
                }
                else{
                    return this.treeStore.includes(this.node.Id);
                }
            },
            inputType:function(){
                return this.singleSelect ? "radio" : "checkbox"
            }
        },
        methods:{
            toggle:function(){
                this.open = !this.open;
            },
            selectTreeNode:function(){
                if(this.checked){
                    this.removeNode(this.node.Id);
                }
                else{
                    this.selectNode(this.node.Id);
                }
            }
        }
    }
</script>